import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Seo from "@/shop/Seo";
import { apiGet, fmt } from "@/shop/api";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id") || "";
  const number = params.get("number") || "";
  const [order, setOrder] = useState(null);
  const [pending, setPending] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!sessionId) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const st = await apiGet(`/api/payments/status/${sessionId}`);
        if (st.payment_status === "paid") {
          const o = await apiGet(`/api/orders/${st.order_number}`);
          setOrder(o);
          setPending(false);
          return;
        }
      } catch {
        /* retry */
      }
      if (tries < 10) timer = setTimeout(poll, 2500);
      else setPending(false);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="bg-ink text-bone min-h-screen flex items-center justify-center px-5" data-testid="checkout-success">
      <Seo title="Grazie — Stillwater" description="Ordine confermato." />
      <div className="max-w-lg text-center py-24">
        {pending ? (
          <>
            <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-ember">Verifica del pagamento…</p>
            <p className="mt-5 font-serif italic text-2xl">Ancora un attimo, stiamo controllando l'acqua.</p>
          </>
        ) : order ? (
          <>
            <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-ember">
              Ordine {order.number} confermato
            </p>
            <h1 className="mt-5 font-serif font-light text-4xl tracking-tight">
              Grazie, <span className="italic text-ember">a presto in riva</span>
            </h1>
            <div className="mt-8 border border-ink-border bg-ink-surface p-6 text-left" data-testid="order-summary">
              {order.items?.map((i, idx) => (
                <div key={idx} className="flex justify-between gap-4 py-2 text-sm">
                  <span className="text-mist">{i.brand} — {i.name} × {i.qty}</span>
                  <span className="font-mono">{fmt(i.price * i.qty)}</span>
                </div>
              ))}
              <div className="flex justify-between gap-4 pt-3 border-t border-ink-border text-sm">
                <span className="text-mist">Spedizione</span>
                <span className="font-mono text-xs">{order.shipping_note || "calcolata dopo la conferma"}</span>
              </div>
              <div className="flex justify-between pt-3 border-t border-ink-border">
                <span className="font-serif italic">Totale pagato</span>
                <span className="font-mono">{fmt(order.total)}</span>
              </div>
            </div>
            <p className="mt-6 text-sm text-mist">
            Riceverai conferma e aggiornamenti all'indirizzo usato durante il pagamento.
            </p>
          </>
        ) : (
          <>
            <p className="font-serif italic text-2xl">Non abbiamo trovato l'ordine.</p>
            <p className="mt-3 text-sm text-mist">
              Se il pagamento è andato a buon fine ti scriveremo via email. Scrivici a redazione@stillwater.it.
            </p>
          </>
        )}
        <Link
          to="/"
          className="mt-10 inline-block font-mono text-[11px] uppercase tracking-[0.25em] border border-bone/30 rounded-full px-7 py-3.5 hover:border-ember hover:text-ember transition-colors"
        >
          Torna al giornale
        </Link>
      </div>
    </div>
  );
}
